import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import HeadOfficeTab from "examples/Tabs/HeadOfficeTab";

function HeadOffice() {
  return (
    <DashboardLayout>
      <HeadOfficeTab />
    </DashboardLayout>
  );
}

export default HeadOffice;